import {Component} from '@angular/core';
import {bankOnboardingSchema} from "./dynamic-section-form-demo-form-schema";
import {DynamicSectionFormSchema} from "../../../dynamic-form-v2/form-schema.types";
import {DynamicSectionFormComponent} from "../dynamic-section-form.component";
import {ThemeService} from "../../../../../services/theme/theme.service";

@Component({
  selector: 'app-dynamic-section-form-demo',
  imports: [
    DynamicSectionFormComponent
  ],
  standalone: true,
  templateUrl: './dynamic-section-form-demo.component.html',
  styleUrl: './dynamic-section-form-demo.component.scss'
})
export class DynamicSectionFormDemoComponent {

  constructor(private themeService: ThemeService) {
    // themeService.setTheme('dark');
  }

  schema: DynamicSectionFormSchema = bankOnboardingSchema;

  entityId = 123;

  existingRecord = {
    bankName: 'Nepal Investment Mega Bank',
    swiftCode: 'NIMBNPKT',
    loanType: 'HOME',
    loanAmount: 2500000,
    interestRate: 9.5,
    hasCoApplicant: true,
    coApplicantName: 'Sita Sharma',
    repaymentMode: 'AUTO_DEBIT',
    autoRenew: true,
  };

  handleFieldChange(event: { key: string; value: any }) {
    console.log('field changed', event.key, event.value);
  }

  onSubmit(sectionForm: DynamicSectionFormComponent) {
    const payload = sectionForm.getValue();
    if (!payload) {
      // form invalid — sectionForm already marked all controls as touched
      return;
    }
    console.log('submit payload', payload);
  }

}
